import React, { useEffect, useMemo, useState } from 'react';
import { useSelector } from 'react-redux';
import { useHistory } from 'react-router';
import {IconBtn, UiSelect} from '@ru-digital-assets/ui-component';
import { get } from 'lodash';
import SignIcon from '../../../assets/icons/sign-icon';
import FormFooter from '../../../containers/form-footer';
import { LoadDocBtn } from '@ru-digital-assets/ui-component';
import Step from '../../../modules/step';
import UiList from '../../../modules/ui/ui-list/ui-list';
import { useAppDispatch } from '../../../store';
import TransactionDetailsTable from '../../../components/TransactionDetailsTable';
import {
  getSale,
  getSaleAgreementDoc,
  holdSale,
  paymentSaleConfirm,
  paymentSaleUpload,
  signSale,
} from '../../../store/actions/operations-sign';
import { RootState } from '../../../types';
import currencyFormat from '../../../utils/currencyFormat';
import {
  downloadFile,
  getPdfFromBase64,
} from '../../../utils/files/downloadFile';
import { getFormatDate } from '../../../utils/utils';
import UcpDocs from '../../ucp-sign/ucp-docs/ucp-docs';
import './index.scss';
import '../../../modules/common-icons/modal.scss';
import '../../../components/key-storage/index.scss';
import { createHash } from 'crypto-pro';
import { PrivateKeyButton } from 'components';
import { useSign } from 'hooks';
import { getSaleStatusBadge } from 'utils/getStatusBadge';
import AppCheckbox from "../../../modules/app-checkbox/app-checkbox";

interface IAssetsSellingInfoForm {
  onSignSale?: () => void;
  onSignPay?: () => void;
}

const AssetsSellingInfoForm = ({
  onSignSale,
  onSignPay,
}: IAssetsSellingInfoForm) => {
  const dispatch = useAppDispatch();
  const history = useHistory();
  const id = history.location.state?.id;
  const [file, setFile] = useState<File>();
  const [approvePayment, setApprovePayment] = useState(false);
  const [approveRisk, setApproveRisk] = useState(false);
  const sale: any = useSelector(
    (state: RootState) => state.operationsSign.data.sale
  );
  const [privateKey, setPrivateKey] = useState('');

  const {
    certificatesList,
    selectedCertificate,
    signEntity,
    onUserSelectCertificate,
  } = useSign();

  console.log('sale', sale);

  const onSpecDownload = (
    title: string,
    type: 'AGREEMENT' | 'COUNTER_APPLICATION' | 'PAYMENT_CONFIRMATION',
    signed: boolean
  ) => {
    id &&
      dispatch(getSaleAgreementDoc({ decisionId: id, type, signed })).then(
        (res: any) => {
          const resultBlob = getPdfFromBase64(res.payload.doc);
          downloadFile(
            resultBlob,
            `${title}.pdf${signed ? '.sig' : ''}`,
            'application/pdf'
          );
        }
      );
  };

  const handleSign = () => {
    id &&
      dispatch(
        getSaleAgreementDoc({
          decisionId: id,
          type: 'COUNTER_APPLICATION',
          signed: false,
          withHash: true,
        })
      ).then(async (res: any) => {
        const { pdfSigned } = await signEntity(res.payload.hash || '');
        if (pdfSigned)
          dispatch(
            signSale({
              hash: res.payload.hash,
              signature: pdfSigned,
              operationId: id,
            })
          ).then(() => dispatch(getSale({ id })));
      });
  };

  const handleCryptoSignHold = async () => {
    if (sale?.status === 'DOC_SIGNED') {
      dispatch(
        holdSale({
          info: {
            operationId: id,
            privateKey: privateKey,
          },
          callback: () => {
            dispatch(getSale({ id }));
            onSignSale && onSignSale();
          },
        })
      );
    }

    if (sale?.status === 'PAYMENT_DOC_UPLOADED') {
      const payload = {
        from: sale?.agentCompanyInfo.id,
        to: sale?.initiatorCompanyInfo.id,
        value: sale?.tokenCount,
        key: privateKey,
      };
      const bufferHash = await createHash(JSON.stringify(payload));
      dispatch(
        paymentSaleConfirm({
          info: {
            id,
            signature: bufferHash,
            payload,
          },
          callback: () => onSignPay && onSignPay(),
        })
      );
    }
  };

  const handleApprove = () => {
    file &&
      dispatch(
        paymentSaleUpload({
          info: {
            id,
            file,
          },
          callback: () => {
            history.push('/assets/result', {
              title: `Подтверждение оплаты успешно отправлено!`,
              titlePage: 'Продажа цифровых финансовых активов',
              description:
                'Ожидайте пока Продавец подтвердит получение денежных средств',
              items: [
                { link: '/assets', title: 'Активы' },
                { link: '#', title: 'Денежные требования' },
              ],
              iconType: 'assets',
            });
          },
        })
      );
  };

  useEffect(() => {
    if (id) {
      dispatch(getSale({ id }));
    }
  }, [id]);

  const decisionDocs = useMemo(() => {
    const docs = [];
    docs.push(
      <LoadDocBtn
        key="sale-agreement"
        title="Договор купли-продажи"
        extension=".PDF"
        onSpecDownload={() =>
          onSpecDownload('Договор купли-продажи', 'AGREEMENT', false)
        }
        secondExtension=".SIG"
        onSecondSpecDownload={() =>
          onSpecDownload('Договор купли-продажи', 'AGREEMENT', true)
        }
      />
    );

    //TODO почему-то некорректно работает для AGENT_DOC_SIGNED
    const isSig = [
      'PAYMENT_DOC_UPLOADED',
      'AGENT_SIGNED',
      'APPLIED',
      'DOC_SIGNED',
      'AGENT_DOC_SIGNED',
    ].includes(sale?.status);

    (
      sale?.status === 'APPLIED' ||
      sale?.status === 'AGENT_SIGNED' ||
      sale?.status === 'AGENT_DOC_SIGNED' ||
      sale?.status === 'PAYMENT_DOC_UPLOADED' ||
      sale?.status === 'APPLIED' ||
      (sale?.status === 'SIGNED' && !sale?.isInitiator)) &&
      docs.push(
        <LoadDocBtn
          key="counter-application"
          title="Встречная заявка"
          extension=".PDF"
          onSpecDownload={() =>
            onSpecDownload('Встречная заявка', 'COUNTER_APPLICATION', false)
          }
          secondExtension={isSig ? '.SIG' : undefined}
          onSecondSpecDownload={
            isSig
              ? () =>
                  onSpecDownload(
                    'Встречная заявка',
                    'COUNTER_APPLICATION',
                    sale?.status === 'AGENT_DOC_SIGNED' ||
                    sale?.status === 'APPLIED' ||
                    sale?.status === 'PAYMENT_DOC_UPLOADED'
                  )
              : undefined
          }
        />
      );

    (sale?.status === 'APPLIED' || sale?.status === 'PAYMENT_DOC_UPLOADED') &&
      docs.push(
        <LoadDocBtn
          key="payment-confirmation"
          title="Подтверждение оплаты"
          onSpecDownload={() =>
            onSpecDownload(
              'Подтверждение оплаты',
              'PAYMENT_CONFIRMATION',
              false
            )
          }
        />
      );

    return docs;
  }, []);

  return (
    <div className="ucp__left">
      <div className="ucp__top">
        {id && sale?.status !== 'APPLIED' && (
          <Step
            steps={[
              { title: 'Параметры' },
              { title: 'Подпись', active: sale?.status === 'DOC_SIGNED' },
              { title: 'Согласование', active: sale?.status === 'SIGNED' },
              {
                title: 'Подтвеждение оплаты',
                active:
                  sale?.status === 'AGENT_SIGNED' ||
                  sale?.status === 'AGENT_DOC_SIGNED' ||
                  sale?.status === 'PAYMENT_DOC_UPLOADED',
              },
            ]}
          />
        )}
        <h3 className="h3">Заявка:</h3>
        <p>
          {`${sale?.isInitiator ? 'Продажа' : 'Покупка'} ${
            sale?.tokenCount || 0
          } токенов ${sale?.tokenTypeInfo || ''} на сумму ${currencyFormat(
            Number(get(sale, 'amount', 0))
          )} от ${getFormatDate(
            get(sale, 'createdAt', new Date()),
            'dd MMM yyyy',
            true
          )}`}
        </p>
        <div className="status">
          {getSaleStatusBadge(sale?.status, sale?.isInitiator)}
        </div>
      </div>
      <div className="ucp__content">
        <div className="ucp__ontractors">
          <h3 className="h3">Детали операции:</h3>
          <div className="ucp__ontractors-body">
            <div className="ucp__ontractors__left">
              <UiList
                list={[
                  {
                    label: 'Продавец:',
                    value: get(sale, 'initiatorCompanyInfo.shortName', ''),
                  },
                  {
                    label: 'ИНН:',
                    value: get(sale, 'initiatorCompanyInfo.tin', ''),
                  },
                ]}
                sm
              />
            </div>
            <div className="ucp__ontractors__right">
              <UiList
                list={[
                  {
                    label: 'Покупатель:',
                    value: get(sale, 'agentCompanyInfo.shortName', ''),
                  },
                  {
                    label: 'ИНН:',
                    value: get(sale, 'agentCompanyInfo.tin', ''),
                  },
                ]}
                sm
              />
            </div>
            <div className="ucp__ontractors__right">
              <UiList
                list={[
                  {
                    label: 'Дата создания:',
                    value: getFormatDate(
                      get(sale, 'createdAt'),
                      undefined,
                      true
                    ),
                  },
                ]}
                sm
              />
            </div>
          </div>
        </div>
        <UcpDocs docs={decisionDocs} />
        <TransactionDetailsTable
          fromHash={sale?.senderBlockchainAddress}
          toHash={sale?.recipientBlockchainAddress}
          fromName={get(sale, 'initiatorCompanyInfo.shortName', '')}
          toName={get(sale, 'agentCompanyInfo.shortName', '')}
          transactionType="sale"
        />
        <FormFooter>
          <div className="flex justify-end form-asset-credit__container">
            {(sale?.status === 'DOC_SIGNED') &&
              sale?.isInitiator && (
                <div className="flex justify-end issuer-footer align-center">
                  <div className="flex justify-end">
                    <div className="mr_10">
                      <PrivateKeyButton
                        onKeyChange={(key) => setPrivateKey(key || '')}
                      />
                    </div>
                    <br />
                    <IconBtn
                      onClick={handleCryptoSignHold}
                      lg
                      disabled={!privateKey}
                      icon={<SignIcon />}
                      title="Подписать транзакцию"
                    />
                  </div>
                </div>
              )}
            {(sale?.status === 'PAYMENT_DOC_UPLOADED') &&
            sale?.isInitiator && (
              <div className="flex issuer-footer align-center">
                <div className="footer__go-back">
                  <AppCheckbox
                    onChangeValue={(val) => {
                      setApprovePayment(val);
                    }}
                    titleComponent={
                      <div className="module-title-text__desc">
                        Подтверждаю, что оплата произведена
                      </div>
                    }
                  />
                </div>
                <div className="flex justify-end">
                  <div className="mr_10">
                    <PrivateKeyButton
                      onKeyChange={(key) => setPrivateKey(key || '')}
                    />
                  </div>
                  <br />
                  <IconBtn
                    onClick={handleCryptoSignHold}
                    lg
                    disabled={!privateKey || !approvePayment}
                    icon={<SignIcon />}
                    title="Подписать транзакцию"
                  />
                </div>
              </div>
            )}
            {sale?.status === 'SIGNED' && !sale?.isInitiator && (
              <div className="flex issuer-footer align-center">
                <div className="footer__go-back">
                  <AppCheckbox
                    onChangeValue={(val) => {
                      setApproveRisk(val);
                    }}
                    titleComponent={
                      <div className="module-title-text__desc">
                        Подтверждаю, что ознакомлен с{' '}
                        <a
                          className="a__link"
                          href="https://account.cfa.digital/risk_declaration.pdf"
                          target="_blank"
                          rel="noreferrer"
                        >
                          декларацией о рисках
                        </a>
                      </div>
                    }
                  />
                </div>
                <div className="flex justify-end issuer-footer align-center">
                  <div className="flex justify-end">
                    <UiSelect
                      label="Выберите подпись:"
                      value={selectedCertificate}
                      options={certificatesList}
                      lg
                      onChange={onUserSelectCertificate}
                    />
                    <IconBtn
                      lg
                      onClick={handleSign}
                      icon={<SignIcon />}
                      disabled={!selectedCertificate || !approveRisk}
                      title="Подать встречную заявку"
                    />
                  </div>
                </div>
              </div>
            )}
            {sale?.status === 'AGENT_DOC_SIGNED' && !sale?.isInitiator && (
              <div className="flex justify-end issuer-footer align-center">
                <div className="flex justify-end">
                  <div className="upload">
                    <LoadDocBtn
                      title={
                        file ? file.name : 'Документ подтверждающий оплату'
                      }
                      extension="Выберите файл"
                      sm={false}
                    />
                    <input
                      id="file"
                      type="file"
                      onChange={(e: any) => setFile(e.target.files[0])}
                    />
                  </div>
                  <IconBtn
                    onClick={handleApprove}
                    lg
                    disabled={!file}
                    icon={<SignIcon />}
                    title="Подтвердить оплату"
                  />
                </div>
              </div>
            )}
          </div>
        </FormFooter>
      </div>
    </div>
  );
};

export default AssetsSellingInfoForm;
